import type { DocBlock } from "./blockTypes.js";

/** Depth-first flatten for formula evaluation and PDF walks. */
export function flattenDocBlocks(blocks: readonly DocBlock[]): DocBlock[] {
  const out: DocBlock[] = [];
  for (const block of blocks) {
    out.push(block);
    if (block.type === "two_column") {
      out.push(...flattenDocBlocks(block.left));
      out.push(...flattenDocBlocks(block.right));
    }
  }
  return out;
}
